/*global $, document, window, setTimeout, alert, typeof, FG*/
/**
 * Frontgate AJAX class
 *
 *  Knows how to consume a standard FGResponse Object
 *  Messaging is standardized
 *  Callback support with argument overloading
 *  No HTTP error codes will be used, ever.
 *  Client side caching is employed for Request next check TTL
 *  Job queing support
 * @author spatel
 * @since 7/26/2013
 * @depends jQuery 1.9.1
 */
(function () {
    "use strict";

    /**
     * Ajax object contaier
     * @param {string}    url   URL to send request to
     * @returns {FG.Ajax}
     * @constructor
     */
    FG.Ajax = function (url) {
        this.url = url;
        this.db = new FG.DB();
        return this;
    };

    /**
     * Ajax exception object
     * @param {string}  message     Exception error message
     * @constructor
     */
    function AjaxException(message) {
        this.msg = message;
        this.name = 'AjaxException';
    }

    /**
     * Extend the base AJAX object
     */
    FG.Ajax.prototype = {

        /**
         * Allow for instantiating
         * @constructor
         */
        constructor : FG.Ajax('dev/null'),

        /**
         * Local store
         * @type {FG.DB}
         */
        db : null,

        /**
         * Reference to jquery XHR object
         * @var {jqxhr}
         */
        xhr: null,

        /**
         * URL to send request to
         * @type {string}
         */
        url: null,

        /**
         * If this is set to true, then there will be no prefix to the URL you hit
         * @type {bool}
         */
        urlOverride : false,

        /**
         * Request type to send to the server
         * [GET, POST, PUT, DELETE]
         *
         * @var {string}
         */
        requestType: 'POST',

        /**
         * Return data type you expect back from the server
         * [default: Intelligent Guess (xml, json, script, or html)]
         *
         * @var {string}
         */
        dataType: 'json',

        /**
         * Request data object to send to the server
         * @var {Object}
         */
        requestData: {},

        /**
         * Callback function to call when the request succeeds
         * @var {Object}
         */
        successCallback: undefined,

        /**
         * Callback function to call when method fails
         * @var {Object}
         */
        failureCallback: undefined,

        /**
         * A DIV Id in the DOM that represents messaging to the end user
         * @var {string}
         */
        messageDiv: '#div-message',

        /**
         * Current timestamp from the server
         * @var {number}
         */
        currentTimestamp : undefined,

        /**
         * Cart expiry timestamp
         * @var {number}
         */
        cartExpiryTimestamp : undefined,

        /**
         * Session expiry timestamp
         * @var {number}
         */
        sessionExpiryTimestamp : undefined,

        /**
         * Job wait next check timestamp
         * @var {number}
         */
        jobWaitTimestamp : undefined,

        /**
         * Should the success message be hidden after a setTimeout
         * @var {boolean}
         */
        hideSuccessMessage: true,

        /**
         * Should the email sent message be shown
         * @var {boolean}
         */
        showEmailSentMessage: false,
        
        /**
         * Send a request to the server
         * @return bool
         * @throws AjaxException
         */
        send: function () {

            var self = this,
                /**
                 * All handler calls require this prefix
                 * @type {string}
                 */
                labelRoot = window.labelRoot + '/',
                requestURL = this.urlOverride == true ? this.url : labelRoot + this.url;

            //If we cannot validated required send parameters, then throw an exception
            if (!self.validateSend()) {
                throw new AjaxException('Cannot validate send, an unknown error occurred.');
            }

            /**
             * jQuery AJAX object
             * @type {jqxhr}
             */
            this.xhr = $.ajax(
                requestURL,
                {
                    type: self.requestType,
                    dataType: self.dataType,
                    data: self.requestData
                }
            ).done(function (FGResponse) {

                //If the standby code throws this exception, regex out the -buy from URL and redirect
                if(FGResponse.errorType == 'StandbyUnauthenticatedException' || FGResponse.errorType == 'StandbyFailedAuthenticationException'){
                    window.location.reload();
                    return false;
                }

                //Parse a standard response
                /**
                 * Persist globally required values into local storage contained in this response
                 * These values keep track of session expiry and cart expiry
                 */
                self.persist(FGResponse);
                
                var message = self.showEmailSentMessage ? 'Email sent' : FGResponse.msg;
                var $btnForgotPassword = $('#btn-forgot-password');
                var $inputEmail = $("#txt-forgot-email");
                
                //If the response contains no error flag
                if (FGResponse.error == 0 || FGResponse.error == false) {

                    //Call the success callback method
                    if (typeof self.successCallback == 'function') {
                        self.successCallback(FGResponse);
                    }

                    //Render a success message to DOM
                    self.success(message);
                    if (self.showEmailSentMessage) {
                        $inputEmail.attr('disabled', 'disabled');
                        $btnForgotPassword.attr('disabled', 'disabled');
                    }

                } else { //There was an error

                    //Call the failure callback method
                    if (typeof self.failureCallback == 'function') {
                        self.failureCallback(FGResponse);
                    }

                    //Render a failure message to the DOM
                    self.error(message);
                    if (self.showEmailSentMessage) {
                        $inputEmail.attr('disabled', 'disabled');
                        $btnForgotPassword.attr('disabled', 'disabled');
                    }
                }
            }).fail(function(jqXHR, textStatus, errorThrown) {
                //Call the failure callback method
                self.msg = 'An unexpected error occurred. Please try again.'
                if (typeof self.failureCallback === 'function') {
                    self.failureCallback(self);
                }

                //Render a failure message to the DOM
                self.error('An unexpected error occurred. Please try again.');
            });
        },

        /**
         * Validate the send method and ensure that all required data is set
         * @private
         * @return bool
         * @throws AjaxException
         */
        validateSend: function () {

            if (this.url == null) {
                throw new AjaxException('URL cannot be null');
            }

            return true;
        },

        /**
         * Ensure that we don't have a wait time set till the next job check
         * If we have a job wait set, and the user tries to fire off another ajax call,
         * then they should see a modal that blocks the entire UI
         * @private
         * @return bool
         */
        validateJob : function () {
            //var currentTimestamp = this.getCurrentTimestamp();
            //var jobWaitTimestamp = this.getJobWaitTimestamp();
        },

        /**
         * Persist some global data properties to local storage.
         * @param {FGResponse}  FGResponse  Standard response that comes from server
         * @private
         */
        persist: function (FGResponse) {
            //If the standby code throws this exception, regex out the -buy from URL and redirect
            if(typeof FGResponse == "undefined" || FGResponse.errorType == 'StandbyUnauthenticatedException' || FGResponse.errorType == 'StandbyFailedAuthenticationException'){
                    window.location.reload();
                    return false;
            }

            //Set a session expiry in local storage
            if (FGResponse.sessionExpiry !== null && FGResponse.sessionExpiry !== undefined) {
                this.persistSessionExpiry(FGResponse.sessionExpiry);
            }

            //If this response is a job, then set the wait seconds
            if (FGResponse.isJob) {
                this.persistJobWait(FGResponse.waitTimestamp);
            }
        },


        /**
         * Get the current timestamp (server TS)
         * @return {number}
         */
        getCurrentTimestamp : function () {

            return FG.Base.getCurrentTimestamp();
        },

        /**
         * Save session expiry to local storage
         * @param {number}   sessionExpiry  UNIX timestamp in the future when the session will expire
         * @private
         */
        persistSessionExpiry: function (sessionExpiry) {

            var currentTimestamp = this.getCurrentTimestamp();

            sessionExpiry = sessionExpiry + currentTimestamp;

            this.db.set('sessionExpiry', sessionExpiry);
        },

        /**
         * If this is a job, then we need to persist the number of seconds to wait before they can try polling again
         * @param {number}  waitTimestamp    Number of seconds to wait before polling the server again
         * @private
         */
        persistJobWait: function (waitTimestamp) {

            if (waitTimestamp !== null && waitTimestamp !== undefined) {

                var db = new FG.DB();

                db.set('waitTimestamp', waitTimestamp);

                this.jobWaitTimestamp = waitTimestamp;
            }
        },

        /**
         * Get the job wait time in seconds
         */
        getJobWaitTimestamp : function () {

            var self = this;

            var db = new FG.DB();

            self.jobWaitTimestamp = db.get('waitTimestamp');

            if (this.jobWaitTimestamp !== undefined) {
                return this.jobWaitTimestamp;
            }
            return null;
        },


        /**
         * Setter for URL
         * @param url
         */
        setURL: function (url) {
            this.url = url;
        },

        /**
         * Set an override on this URL
         * @param {boolean} urlOverride
         */
        setURLOverride : function(urlOverride){
            this.urlOverride = urlOverride;
        },

        /**
         * Setter for request type
         * @param {string}  requestType     Type of request
         */
        setRequestType: function (requestType) {
            this.requestType = requestType;
        },

        /**
         * Set an object to send to the server as request data
         * @param {Object}  requestData Data to send to server
         */
        setRequestData: function (requestData) {
            this.requestData = requestData;
        },

        /**
         * Set an object to send to the server as request data
         * @param {Object}  requestData Data to send to server
         */
        setData : function (requestData) {
            this.requestData = requestData;
        },

        /**
         * Success callback method
         * @param {function}  successCallback     Function to call when success
         */
        setSuccessCallback: function (successCallback) {
            this.successCallback = successCallback;
        },

        /**
         * Set a failure callback method
         * @param {function}    failureCallback     Function to call when failure
         */
        setFailureCallback: function (failureCallback) {
            this.failureCallback = failureCallback;
        },

        /**
         * Setter for DOM Id of element to show error messaging
         * @param {string}  messageDiv    divID
         */
        setMessageDiv: function (messageDiv) {
            this.messageDiv = messageDiv;
        },

        /**
         * Setter to hide/show the success message div
         * @param {boolean} hideSuccessMessage
         */
        setHideSuccessMessage: function(hideSuccessMessage){
            this.hideSuccessMessage = hideSuccessMessage;
        },

        /**
         * Setter to hide/show the email sent message div
         * @param {boolean} showEmailSentMessage
         */
         setShowEmailSentMessage: function(showEmailSentMessage){
            this.showEmailSentMessage = showEmailSentMessage;
        },
        
        /**
         * Render an error message to the DOM with the appropriate styling.
         * @param {string}  msg Message to render
         */
        error : function (msg) {
            var self = this;
            if (msg !== '' && msg !== null && msg !== undefined) {

                var $errorDiv = this.messageDiv;

                if (typeof $errorDiv == 'string') {
                    $errorDiv = $($errorDiv);
                }

                if ($errorDiv !== '' && $errorDiv !== null && $errorDiv !== undefined) { 
                    $errorDiv.slideDown('slow', function () {
                        self.showEmailSentMessage ? $(this).addClass('alert').addClass('alert-success') : $(this).addClass('alert').removeClass('alert-success');
                        $(this).html(msg)
                            .show();
                    });
                    if (self.showEmailSentMessage) {
                        self.setShowEmailSentMessage(false);
                        $("#txt-forgot-email").attr("disabled", "disabled");
                        $("#btn-forgot-password").attr("disabled", "disabled");
                        setTimeout(function () {
                            $($errorDiv).slideUp(function () {
                                $(this).hide();
                            });
                        }, 3000);
                    }
                }
                
            }
        },

        /**
         * Render a success message to the DOM with the appropriate styling.
         * @param {string}  msg Message to render
         */
        success : function (msg) {

            var self = this;

            if (msg !== '' && msg !== null && msg !== undefined) {

                $(this.messageDiv).slideDown('slow', function () {

                    $(this).html(msg)
                        .addClass('alert')
                        .addClass('alert-success')
                        .removeClass('alert-error')
                        .show();
                });

                if(this.hideSuccessMessage){
                    setTimeout(function () {
                        $(self.messageDiv).slideUp(function () {
                            $(this).hide();
                        });
                        if (self.showEmailSentMessage) {
                            self.setShowEmailSentMessage(false);
                        }
                    }, 3000);
                }
            }
        }
    };
}());
